import PropTypes from 'prop-types';

const LoadingIndicator = ({ stage = 'thinking', estimatedTime = '2-3 seconds' }) => {
  const stages = {
    thinking: 'AI is thinking...',
    processing: 'Processing query...',
    analyzing: 'Analyzing data...',
    generating: 'Generating insights...'
  };

  return (
    <div className="w-full px-4 py-3">
      <div className="flex justify-start">
        <div className="max-w-2xl lg:max-w-4xl px-6 py-4 rounded-2xl shadow-md bg-white border border-gray-200">
          <div className="flex items-start gap-3">
            {/* AI Avatar Badge */}
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white text-sm font-semibold">
              AI
            </div>

            {/* Loading content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-3">
                <div className="flex gap-1">
                  <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                  <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                  <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                </div>
                <span className="text-sm font-medium text-blue-900">{stages[stage]}</span>
              </div>

              {/* Skeleton lines */}
              <div className="space-y-2">
                <div className="h-3 bg-gray-200 rounded animate-pulse w-full"></div>
                <div className="h-3 bg-gray-200 rounded animate-pulse w-5/6"></div>
                <div className="h-3 bg-gray-200 rounded animate-pulse w-4/6"></div>
              </div>

              {/* Estimated time */}
              {estimatedTime && (
                <p className="text-xs text-gray-500 mt-3">
                  Usually takes {estimatedTime}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

LoadingIndicator.propTypes = {
  stage: PropTypes.oneOf(['thinking', 'processing', 'analyzing', 'generating']),
  estimatedTime: PropTypes.string
};

export default LoadingIndicator;
